import { render, staticRenderFns } from "./JobGradeLeader.vue?vue&type=template&id=026c20a0&scoped=true"
import script from "./JobGradeLeader.vue?vue&type=script&lang=js"
export * from "./JobGradeLeader.vue?vue&type=script&lang=js"
import style0 from "./JobGradeLeader.vue?vue&type=style&index=0&id=026c20a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026c20a0",
  null
  
)

export default component.exports